import React, { useState, useEffect, useContext } from "react";
import { certificateService } from "../../Services/certificate.service";
import CardWrap from "../Common/CardWrap";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DatePicker, { registerLocale } from "react-datepicker";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import * as dateHelper from "../../Helpers/DateHelper";
import ResultModal from "../Common/ResultModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import Tooltip from "../Common/Tooltip";
import { lettersAndNumbers } from "../../Config/Regex";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
registerLocale("hr", hr);
registerLocale("en", en);

const CertificateUpdate = (props) => {
  let id = props.match.params.certificateId;
  const { locName, locTenant, selectedLanguageId } = useContext(GlobalContext);
  const [certificate, setCertificate] = useState({});

  const history = useHistory();
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    certificateService
      .getById(id)
      .then((res) => setCertificate(res.data))
      .catch((err) => console.log(err));
  }, []);

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCertificate({ ...certificate, [name]: value });
  };

  const onSubmit = () => {
    certificateService
      .updateCert(
        certificate.certificateId,
        certificate.validFrom,
        certificate.validTo,
        certificate.certPassword,
        certificate.name
      )
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("CertificateUpdate-SuccesModal-Title"),
              text: translator("CertificateUpdate-SuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("CertificateUpdate-UnsuccesModal-Title"),
              text: translator(res.data.message || "CertificateUpdate-UnsuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("CertificateUpdate-UnsuccesModal-Title"),
          text: translator(err?.response?.data?.message || "CertificateUpdate-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const goBack = () => {
    history.push(`/${locName}/${locTenant}`);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <CardWrap subtitle={translator("Certificate-Update-Title")}>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Certificate-Update-Legend")}
            </legend>

            <div className="form-group">
              <label>{translator("Certificate-Update-Name")}</label>{" "}
              <Tooltip text={translator("Certificate-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                name="name"
                ref={register({
                  required: true,
                  maxLength: 50,
                  //pattern: lettersAndNumbers,
                })}
                value={certificate.name}
                disabled={false}
                onChange={handleInputChange}
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength50")}
                </p>
              )}
              {errors.name && errors.name.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersAndNumbers")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Password")}</label>{" "}
              <Tooltip text={translator("Certificate-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                name="certPassword"
                ref={register({
                  required: false,
                  maxLength: 50,
                })}
                onChange={handleInputChange}
              />
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-CertificateData-Subscription")}
            </legend>
            <div className="form-group">
              <label>{translator("Certificate-Upload-ValidFrom")}</label>{" "}
              <Tooltip text={translator("Certificate-ValidFrom-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="validFrom"
                  showYearDropdown={true}
                  selected={
                    certificate.validFrom && new Date(certificate.validFrom)
                  }
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  onChange={function ([selected]) {
                    handleInputChange({
                      target: {
                        name: "validFrom",
                        value: dateHelper.datePickerDateToUtc(selected),
                      },
                    });
                    return selected;
                  }}
                  maxDate={new Date(certificate.validTo)}
                />
              </div>
            </div>
            <div className="form-group">
              <label>{translator("Certificate-Upload-ValidTo")}</label>{" "}
              <Tooltip text={translator("Certificate-ValidTo-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="validTo"
                  showYearDropdown={true}
                  selected={
                    certificate.validTo && new Date(certificate.validTo)
                  }
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  onChange={function ([selected]) {
                    handleInputChange({
                      target: {
                        name: "validTo",
                        value: dateHelper.datePickerDateToUtc(selected),
                      },
                    });
                    return selected;
                  }}
                  minDate={new Date(certificate.validFrom)}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
};

export default CertificateUpdate;
